import PropTypes from 'prop-types';
import PromotionSlider from 'components/content-components/Promotional/PromotionSlider';

const FeaturePromotion = ({
    columnSizes = [],
    features = [],
    heading,
    headingFontKeys = ['Primary/32_110_-2', null, 'Primary/40_100_-2'],
    id,
    imageSettings = {},
    paragraph,
    sbEditable,
    slidesPerView,
    tag,
}) => {
    if (features.length < 1) {
        return null;
    }

    return (
        <PromotionSlider
            $style={{ padding: ['64px 8px', null, null, null, null, '64px 24px'] }}
            columnSizes={columnSizes}
            heading={heading}
            headingFontKeys={headingFontKeys}
            id={id}
            imageSettings={imageSettings}
            items={features}
            paragraph={paragraph}
            sbEditable={sbEditable}
            slidesPerView={slidesPerView}
            tag={tag}
            type="feature"
        />
    );
};

FeaturePromotion.propTypes = {
    columnSizes: PropTypes.array,
    features: PropTypes.array,
    heading: PropTypes.object,
    headingFontKeys: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    id: PropTypes.string,
    imageSettings: PropTypes.shape({
        width: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
        sizes: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    }).isRequired,
    paragraph: PropTypes.object,
    sbEditable: PropTypes.object,
    slidesPerView: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
    tag: PropTypes.object,
};

export default FeaturePromotion;
